import React from 'react';

import IconSpill from 'components/icons/spill';

const Icon = () => <IconSpill width="172" height="192" />;

export default Icon;
